import AbstractApiReducer from "services/cores/abstractApiReducer";
import DisplaysActionTypes from "./types";

const INITIAL_DISPLAYS_STATE = {
  autoRefresh: true,
  list: {
    orders: {},
  },
  map: {
    selectedLayers: [],
  },
};

class DisplaysReducer extends AbstractApiReducer {
  constructor() {
    super(DisplaysActionTypes, INITIAL_DISPLAYS_STATE);
    this.mapActionToMethods[DisplaysActionTypes.SET_AUTO_REFRESH] =
      this.setAutoRefresh;
    this.mapActionToMethods[DisplaysActionTypes.SET_SELECTED_LAYERS] =
      this.setSelectedLayers;
  }

  setAutoRefresh = (state, action) => {
    return {
      ...state,
      autoRefresh: action.autoRefresh,
    };
  };

  setSelectedLayers = (state, action) => {
    return {
      ...state,
      map: {
        ...state.map,
        selectedLayers: action.layers,
      },
    };
  };
}
const instance = new DisplaysReducer();
export default instance.reducer;
